// @ts-nocheck
import React from "react";
import useStore from "../../store/useStore";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";

export default function ModalDataRoute() {
  const { routeGPS, employeeClockIns } = useStore((state) => state);

  const combineAndSortData = () => {
    // Ensure we have arrays to work with, even if empty
    const clockIns = employeeClockIns || [];
    const gpsData = routeGPS?.all_pings || [];

    // Convert clockIns to the required format
    const clockInRows = clockIns.map((clockIn) => ({
      batidaDoPonto: `${clockIn.hora} ${clockIn.tipo_batida}`,
      dataHora: `${clockIn.data}T${clockIn.hora}`,
      latitude: Number(clockIn.latitude),
      longitude: Number(clockIn.longitude),
      isClockIn: true,
    }));

    // Format GPS data
    const gpsRows = gpsData.map((gps) => ({
      batidaDoPonto: "-",
      dataHora: gps.data_hora,
      latitude: Number(gps.latitude),
      longitude: Number(gps.longitude),
      isClockIn: false,
    }));

    // Combine and sort all data
    const allData = [...clockInRows, ...gpsRows].sort(
      (a, b) => new Date(a.dataHora) - new Date(b.dataHora)
    );

    return allData;
  };

  const formatDataHora = (dataHora) => {
    return new Date(dataHora).toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const formatNumber = (value) => {
    const num = Number(value);
    return isNaN(num) ? "0.000000" : num.toFixed(6);
  };

  // Add safe access to properties with default values
  const clockInsLength = employeeClockIns?.length || 0;
  const allPingsLength = routeGPS?.all_pings?.length || 0;
  const pingsInsideLength = routeGPS?.pings_inside_clockins?.length || 0;
  const pingsOutsideLength = routeGPS?.pings_outside_clockins?.length || 0;

  return (
    <div className="bg-transparent rounded-lg h-full flex flex-col items-center justify-center">
      <Dialog>
        <DialogTrigger asChild>
          <Button
            className="w-full border-2 border-orange-300 text-orange-300 text-md font-bold py-2 px-4 
                      rounded-md hover:bg-orange-300 hover:text-gray-500 transition duration-300 
                      tracking-wider uppercase bg-transparent h-9"
          >
            Mostrar dados
          </Button>
        </DialogTrigger>
        <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Dados do Rastreamento</DialogTitle>
            <div>
              <p className="text-sm text-gray-100">
                {`Quantidade de batidas do ponto: ${clockInsLength} batidas`}
              </p>
              <p className="text-sm text-gray-100">
                {`Número de registros do GPS: ${allPingsLength} registros`}
              </p>
              <p className="text-sm text-gray-100">
                {`Registros dentro do horário: ${pingsInsideLength}`}
              </p>
              <p className="text-sm text-gray-100">
                {`Registros fora do horário: ${pingsOutsideLength}`}
              </p>
            </div>
          </DialogHeader>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-[150px]">Batida do Ponto</TableHead>
                <TableHead>Data-Hora</TableHead>
                <TableHead>Latitude</TableHead>
                <TableHead>Longitude</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {combineAndSortData().map((row, index) => (
                <TableRow key={index} className={row.isClockIn ? "bg-blue-500" : ""}>
                  <TableCell className="font-medium">{row.batidaDoPonto}</TableCell>
                  <TableCell>{formatDataHora(row.dataHora)}</TableCell>
                  <TableCell>{formatNumber(row.latitude)}</TableCell>
                  <TableCell>{formatNumber(row.longitude)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
    </div>
  );
}
